<template>
  <div class="cus-chat-view">
    <div class="cus-chat-view-search">
      <el-radio-group
        v-model="radio"
        size="small"
        style="margin-right: 10px"
        @change="selectSearchType"
      >
        <el-radio-button label="今日"></el-radio-button>
        <el-radio-button label="昨日"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        size="small"
        v-model="searchDate"
        type="daterange"
        :editable="false"
        @change="selectDate"
        value-format="yyyy-MM-dd"
        range-separator="~"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:240px;margin-right: 10px;padding: 2px 10px;"
      >
      </el-date-picker>
      <el-button size="small" type="primary" @click="reset">重置</el-button>
    </div>
    <div class="below">
      <div style="flex: 8;">
        <CusChatCommon
          v-bind:idData="idSet"
          ref="cusChat"
          @msgType="handleMsgType"
          :start="startTime"
          :end="endTime"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CusChatCommon from "./CusChatCommon";
import { getCustomerContactList } from "../../../api/customer/customer.js";
import { getGroupMsg } from "../../../api/group/index.js";
import dayjs from "dayjs";
export default {
  name: "CusChatView",
  props: {
    idData: {
      type: String,
      default: "",
    },
  },
  components: {
    CusChatCommon,
  },
  data() {
    return {
      searchDate: [],
      startTime: "",
      endTime: "",
      startTimeDefault: "2021-01-01",
      endTimeDefault: "",
      current: 1,
      size: 10,
      loading: true,
      uid: this.idData,
      cid: "",
      idSet: [],
      radio: "",
      inputName: "",
      msgSort: "",
      dataFirst: [],
      dataNew: [],
      list: JSON.parse(localStorage.getItem("routerList")),
      myDepartment: JSON.parse(localStorage.getItem("myDepartment")),
      flatList: [],
      ISH: false,
      ISO: false,
      msgType: "text",
    };
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    handleMsgType(type) {
      console.log(type);
      this.msgType = type;
    },
    select(val) {
      // this.handleLimits();
      console.log(
        "该员工的权限设置 myDepartment ",
        this.myDepartment,
        val.departmentId
      );
      if (this.ISH && this.myDepartment == val.departmentId) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else if (this.ISO && this.myDepartment != val.departmentId) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else if (this.ISO && this.ISH) {
        this.cid = val.uid;
        this.idSet = [this.uid, this.cid];
      } else {
        this.$message.warning("暂无权限查看聊天记录");
      }
    },
    handleDisable(data) {
      console.log("查看记录权限", data);
    },
    handleLimits() {
      this.handleFlat(this.$store.state.tagsView.routerList);
      this.flatList.forEach((item) => {
        if (item.menuId == "85") {
          this.ISH = true;
        }
        if (item.menuId == "86") {
          this.ISO = true;
        }
      });
    },
    // 扁平化数组
    handleFlat(list) {
      list.forEach((item) => {
        if (item.menus.length <= 0) {
          this.flatList.push({ menuName: item.menuName, menuId: item.menuId });
        } else {
          this.handleFlat(item.menus);
        }
      });
    },
    getToday() {
      var date = new Date();
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    getYesterday() {
      var date = new Date();
      date = new Date(date - 1000 * 60 * 60 * 24);
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    getContactList(
      sendFrom,
      startTime,
      endTime,
      current,
      size,
      msgType = "text"
    ) {
      this.loading = true;
      // console.log('test')
      // console.log('nnn')
      // console.log("sendFrom",sendFrom)
      // console.log("startTime",startTime)
      // console.log("endTime",endTime)
      // console.log("current",current)
      // console.log("size",size)
      let obj = {
        chatId: sendFrom,
        msgType,
        startTime: startTime,
        endTime: endTime,
        current: current,
        size: size,
      };
      this.$nextTick(() => {
        // console.log( this.$refs.cusChat.msgSort = 'text')
        this.$refs.cusChat.getDialog(obj);
      });
      // return;
      // return;
      // getGroupMsg(
      //   obj,
      //   localStorage.getItem("Authorization"),
      // ).then((list) => {
      //   // this.dataFirst = this.dataNew = list.data;
      //   console.log('list', list)
      //   this.loading = false;
      // });
    },

    selectDate() {
      this.idSet = [];
      this.current = 1;
      if (this.searchDate != null) {
        this.startTime = this.searchDate[0];
        this.endTime = this.searchDate[1];
        this.radio = "选择日期";
      } else {
        this.startTime = this.startTimeDefault;
        this.endTime = this.endTimeDefault;
        this.radio = "";
      }
      this.getContactList(
        this.uid,
        this.startTime,
        this.endTime,
        this.current,
        this.size
      );
    },

    searchName(keywords) {
      return this.dataFirst.filter((item) => {
        if (item.name.includes(keywords)) {
          return item;
        }
      });
    },

    displayLength(str, length) {
      var displayLength = 0;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) <= 40869 && str.charCodeAt(i) >= 19968) {
          displayLength++;
        }
        displayLength++;
      }
      displayLength = length - displayLength + str.length;

      return displayLength;
    },

    isYesterday(time) {
      var today = new Date();
      var yesterday = new Date(today - 1000 * 60 * 60 * 24);
      var test = new Date(time);
      if (
        yesterday.getYear() === test.getYear() &&
        yesterday.getMonth() === test.getMonth() &&
        yesterday.getDate() === test.getDate()
      ) {
        return true;
      } else {
        return false;
      }
    },

    displayTimeStr(timeStr) {
      var day = new Date(timeStr).getDay();
      var time = new Date(timeStr).getTime();
      var timeNow = Date.parse(new Date());

      var timeDiffer = timeNow - time;
      if (timeDiffer <= 60000) {
        //一分钟内
        var returnTime = "刚刚";
      } else if (
        timeDiffer > 60000 &&
        timeDiffer < 86400000 &&
        this.isYesterday(time) === false
      ) {
        //今日
        var returnTime = "今天";
      } else if (timeDiffer > 60000 && this.isYesterday(time) === true) {
        //昨天
        var returnTime = "昨天";
      } else if (timeDiffer >= 86400000 && timeDiffer < 60000 * 60 * 24 * 7) {
        var returnTime = "星期" + "日一二三四五六".charAt(day);
      } else var returnTime = timeStr;

      return returnTime;
    },

    selectSearchType() {
      this.idSet = [];
      if (this.radio == "今日") {
        this.startTime = this.getToday();
        this.endTime = this.getToday();
        this.current = 1;
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size,
          this.msgType
        );
      } else if (this.radio == "昨日") {
        this.startTime = this.getYesterday();
        this.endTime = this.getYesterday();
        this.current = 1;
        this.getContactList(
          this.uid,
          this.startTime,
          this.endTime,
          this.current,
          this.size,
          this.msgType
        );
      }
    },

    reset() {
      this.searchDate = [];
      this.idSet = [];
      this.startTime = "";
      this.endTime = dayjs().format("YYYY-MM-DD");
      this.current = 1;
      this.radio = "";
      this.getContactList(
        this.uid,
        this.startTime,
        this.endTime,
        this.current,
        this.size,
        this.msgType
      );
    },
  },

  created() {
    this.endTime = this.endTimeDefault = this.getToday();
    this.getContactList(
      this.uid,
      this.startTime,
      this.endTime,
      this.current,
      this.size
    );
  },

  watch: {
    idData: {
      handler(newVal, oldVal) {
        this.idSet = [];
        this.inputName = "";
        this.uid = newVal;
        this.current = 1;
        this.getContactList(
          newVal,
          this.startTime,
          this.endTime,
          this.current,
          this.size
        );
      },
    },

    inputName: function(val) {
      if (val == "") {
        this.dataNew = this.dataFirst;
      } else {
        this.dataNew = this.searchName(val);
      }
    },

    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX 聊天审计-客户列表", newVal);

        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "聊天审计-客户列表") {
              console.log("XXXXXXXX 聊天审计-客户列表", newVal);
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("ltjlckkubbm") != -1) {
                // 可查看本部门
                this.ISH = true;
              } else {
                // this.senGroupOption = false
                this.ISH = false;
              }
              if (senBtnAuthority.indexOf("ltjlckkukbm") != -1) {
                // 可查看外部门
                this.ISO = true;
              } else {
                this.ISO = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.cus-chat-view {
  .cus-chat-view-search {
    margin-bottom: 10px;
  }

  .below {
    display: flex;
    justify-content: space-around;
    border: 1px solid #e6e6e6;

    .l-nav {
      display: flex;
      flex-direction: column;
      width: 280px;
      border-right: 1px solid #e6e6e6;

      .common-class {
        width: 100% !important;
        height: 100% !important;
      }

      .name-list {
        flex: 1;

        /deep/ .el-scrollbar__view {
          width: 100% !important;
          height: 100% !important;
        }

        /deep/ .is-scrolling-none {
          width: 100% !important;
          height: 100% !important;
        }

        .chat-type {
          /deep/ .el-menu {
            border-right: 0 !important;
          }

          /deep/ .el-table--fit {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
    }

    .category {
      width: 100%;

      /deep/.el-tabs__header {
        margin: 0 !important;

        .el-tabs__item.is-active {
          border-bottom: none !important;
        }

        .el-tabs__nav {
          border: none !important;
        }

        .el-tabs__item {
          border-left: none;
          border-right: 1px solid #e4e7ed;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(177, 181, 189, 0.5);
  border-radius: 5px;
}
</style>
